import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { ProductListItemModel } from 'autogen/swagger/all';
import { ProductRecommendedWith } from 'autogen/translation-keys/trans-website-productcrosssell';
import { Typography } from 'components/generic/typography';
import HorizontalProductItem from 'components/shared/productItem/components/HorizontalProductItem/HorizontalProductItem';
import TrackingContext from 'modules/tracking/GA4/helpers/TrackingContext';

const StyledHorizontalProductItem = styled(HorizontalProductItem)`
    border: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
`;

const Container = styled.div`
    display: grid;
    row-gap: ${({ theme }) => theme.Spacing8};
`;

export default function CrossSellProducts({
    items,
    ...restProps
}: {
    items: ProductListItemModel[] & HTMLAttributes<HTMLDivElement>;
}) {
    const { t } = useTranslation();

    return (
        <TrackingContext eventParams={[{ param_name: 'is_cross_sell', param_value: true }]}>
            <Container {...restProps}>
                <Typography.Body size="L" strong>
                    {t(ProductRecommendedWith)}
                </Typography.Body>
                {items.map((model) => (
                    <StyledHorizontalProductItem key={model.id} model={model} />
                ))}
            </Container>
        </TrackingContext>
    );
}
